// @ts-nocheck

import React, { useState } from "react";
import { FaArrowLeft, FaArrowRight, FaCloudUploadAlt } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { PostApi } from "../../../../../ApiClient/PostApi";
import { Loader2 } from "../../../../loader/Loader";
import { error_toaster, success_toaster } from "../../../../toaster/Toaster";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useEffect } from "react";
export default function SupplierBar() {
  const navigate = useNavigate();
  // const location = useLocation();
  const [data, setData] = useState({
    contactName: "",
    email: "",
    phone: "",
    arrivalDate: "",
    packageTrackingNo: "",
    packageTrackingLink: "",
  });
  const [selectedImage, setSelectedImage] = useState("");

  const [listImage, setListImage] = useState("");
  const [loading, SetLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [isChecked, setIsChecked] = useState(null);
  console.log("🚀 ~ SupplierBar ~ isChecked:", isChecked);

  const handleCheckboxChange = (value) => {
    setIsChecked(value);
  };
  // ERRORS
  const [contactNameError, setcontactNameError] = useState(false);
  const [emailError, setemailError] = useState(false);
  const [phoneError, setphoneError] = useState(false);
  const [sendEmailError, setSendEmailError] = useState(false);
  const [arrivalDateError, setarrivalDateError] = useState(false);
  const [packageTrackingNoError, setpackageTrackingNoError] = useState(false);
  const [packageTrackingLinkError, setpackageTrackingLinkError] =
    useState(false);
  const [selectimageLinkError, setselectimageLinkError] = useState(false);
  const [listimageLinkError, setlistimageLinkError] = useState(false);
  const setNewPhone = (phone) => {
    setPhone(phone);
    setphoneError(false);
  };
  useEffect(() => {
    const storecontactName = localStorage.getItem("contactName");
    const email = localStorage.getItem("email");
    const phone = localStorage.getItem("phone");
    const arrivalDate = localStorage.getItem("arrivalDate");
    const packageTrackingNo = localStorage.getItem("packageTrackingNo");
    const packageTrackingLink = localStorage.getItem("packageTrackingLink");
    setData({
      contactName: storecontactName,
      email: email,
      phone: phone,
      arrivalDate: arrivalDate,
      packageTrackingLink: packageTrackingLink,
      packageTrackingNo: packageTrackingNo,
    });
    // setPhone(localStorage.getItem("countryCode"));
  }, []);
  const onChange = (e) => {
    if (e.target.name === "contactName") {
      setcontactNameError(false);
      localStorage.setItem("contactName", e.target.value);
    }
    if (e.target.name === "email") {
      setemailError(false);
      localStorage.setItem("email", e.target.value);
    }

    if (e.target.name === "phone") {
      alert(e.target.value);
      setphoneError(false);
      localStorage.setItem("phone", e.target.value);
    }
    if (e.target.name === "arrivalDate") {
      const currentDate = new Date().toISOString().split("T")[0];
      const selectedDate = e.target.value;
      if (selectedDate < currentDate) {
        error_toaster("Please select Date after previous Date");
        return false;
      }

      setarrivalDateError(false);
      localStorage.setItem("arrivalDate", e.target.value);
    }
    if (e.target.name === "packageTrackingNo") {
      setpackageTrackingNoError(false);
      localStorage.setItem("packageTrackingNo", e.target.value);
    }
    if (e.target.name === "packageTrackingLink") {
      setpackageTrackingLinkError(false);
      localStorage.setItem("packageTrackingLink", e.target.value);
    }
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const setCountryPhone = (phone) => {
    localStorage.setItem("countryCode", phone);
    setPhone(phone);
  };
  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };
  const add_supplier_detail = async () => {
    const check = validateEmail(data.email);
    if (data.contactName === "" || data.contactName === null) {
      // error_toaster("Please enter Contact Name!");
      setcontactNameError(true);
      return false;
    }
    if (data.email === "" || data.email === null) {
      setemailError(true);
      return false;
    }
    if (check === null) {
      setemailError(true);
      return false;
    }

    if (phone === "" || phone === null) {
      setphoneError(true);
      return false;
    }
    if (isChecked === "" || isChecked === null) {
      setSendEmailError(true);
      return false;
    }
    if (data.arrivalDate === "" || data.arrivalDate === null) {
      setarrivalDateError(true);
      return false;
    }
    if (data.packageTrackingNo === "" || data.packageTrackingNo === null) {
      setpackageTrackingNoError(true);
      return false;
    }
    if (data.packageTrackingLink === "" || data.packageTrackingLink === null) {
      setpackageTrackingLinkError(true);
      return false;
    }

    if (selectedImage === "" || selectedImage === null) {
      setselectimageLinkError(true);
      return false;
    }
    if (listImage === "" || listImage === null) {
      setlistimageLinkError(true);
      return false;
    }

    const formData = new FormData();
    formData.append("contactName", data.contactName);
    formData.append("email", data.email);
    formData.append("phone", "+" + phone);
    formData.append("location", "/consignee_details");
    formData.append("arrivalDate", data.arrivalDate);
    formData.append("trackingNo", data.packageTrackingNo);
    formData.append("trackingLink", data.packageTrackingLink);
    formData.append("back", selectedImage);
    formData.append("front", listImage);
    formData.append("booking_id", localStorage.getItem("orderId"));
    SetLoading(true);
    const res = await PostApi("booking/add_supplier_detail", formData);
    if (res.data.status === "1") {
      SetLoading(false);
      success_toaster(res.data.message);
      localStorage.setItem("sendEmail", isChecked);
      navigate("/consignee_details");
    } else {
      error_toaster(res.data.message);
      SetLoading(false);
    }
  };
  const inputStyle =
    "border-none bg-white rounded p-3 placeholder:text-black placeholder:text-opacity-40 font-normal text-base focus:ring-0 w-full";
  const labelStyle = "font-normal text-black";
  const inputNumber =
    "input::-webkit-outer-spin-button,input::-webkit-inner-spin-button {-webkit-appearance: none;margin: 0;}input[type=number] {-moz-appearance: textfield;}";
  return (
    <>
      <style>{inputNumber}</style>
      {loading ? (
        <div className="absolute left-[60%] top-[40%]">
          <Loader2 />
        </div>
      ) : (
        <div className="xl:col-span-9 lg:col-span-8 bg-themeSecondary py-6 sm:px-8 px-4 space-y-8">
          <div className="flex items-center gap-x-4">
            <div className="bg-white p-2 rounded-fullest">
              <img
                src="images/sendParcel/box-truck.webp"
                alt="box"
                className="w-8"
              />
            </div>
            <h1 className="font-medium text-2xl text-themeBlue">
              Supplier Details
            </h1>
          </div>
          <div className="grid md:grid-cols-12 xl:gap-x-16 md:gap-x-8 gap-y-8">
            <div className="md:col-span-5 space-y-5">
              <h1 className="font-medium text-2xl text-themeBlue">
                Person Information
              </h1>
              <div className="space-y-2">
                <label htmlFor="contactName" className={labelStyle}>
                  Contact Name
                </label>
                <input
                  type="text"
                  placeholder="Contact Name"
                  name="contactName"
                  onChange={onChange}
                  // value={data.contactName === "" ? detail?.data?.data?.contactName : data.contactName}
                  value={data.contactName}
                  id="contactName"
                  className={inputStyle}
                />
                {contactNameError ? (
                  <span className="text-themeRed text-xs">
                    Contact Name is required!
                  </span>
                ) : (
                  ""
                )}
              </div>
              <div className="space-y-2">
                <label htmlFor="email" className={labelStyle}>
                  Email
                </label>
                <input
                  type="email"
                  placeholder="georgia.young@example.com"
                  name="email"
                  onChange={onChange}
                  value={data.email}
                  id="email"
                  className={inputStyle}
                />
                {emailError ? (
                  <span className="text-themeRed text-xs">
                    Email is required!
                  </span>
                ) : (
                  ""
                )}
              </div>
              <div className="space-y-2">
                <label htmlFor="phone" className={labelStyle}>
                  Phone
                </label>
                <div>
                  <PhoneInput
                    inputProps={{ name: "phone", id: "phone" }}
                    inputStyle={{
                      display: "block",
                      width: "100%",
                      paddingTop: "20px",
                      paddingBottom: "20px",
                      color: "black",
                      border: "1px solid #E2E8F0",
                      borderRadius: "6px",
                    }}
                    country={"cn"}
                    value={phone}
                    onChange={(phone) => setNewPhone(phone)}
                  />
                </div>
                {phoneError ? (
                  <span className="text-themeRed text-xs">
                    Phone No. is required!
                  </span>
                ) : (
                  ""
                )}
              </div>

              <div>Do you want us email the package waybill to supplier?</div>
              <div className="flex gap-x-2 items-center">
                <input
                  type="checkbox"
                  name="yes"
                  id="yes"
                  checked={isChecked === true}
                  onChange={() => handleCheckboxChange(true)}
                />
                <label htmlFor="yes">Yes</label>
                <input
                  type="checkbox"
                  name="no"
                  id="no"
                  checked={isChecked === false}
                  onChange={() => handleCheckboxChange(false)}
                />
                <label htmlFor="no">No</label>
              </div>
              {sendEmailError ? (
                <span className="text-themeRed text-xs">
                  Send Email the Package Waybill to Supplier is required!
                </span>
              ) : (
                ""
              )}
            </div>
            <div className="md:col-span-7 space-y-8">
              <h1 className="font-medium text-2xl text-themeRed">
                Tracking information
              </h1>
              <div className="space-y-2">
                <label htmlFor="arrivalDate" className={labelStyle}>
                  Expected Hub Arrival Date & Time
                </label>
                <input
                  min={new Date().toISOString().split("T")[0]}
                  type="datetime-local"
                  placeholder="Expected arrival Date at hub"
                  name="arrivalDate"
                  onChange={onChange}
                  value={data.arrivalDate}
                  id="arrivalDate"
                  className={inputStyle}
                />
                {arrivalDateError ? (
                  <span className="text-themeRed text-xs">
                    Arrival Date is required!
                  </span>
                ) : (
                  ""
                )}
              </div>
              <div className="space-y-2">
                <label htmlFor="packageTrackingNo" className={labelStyle}>
                  Package Tracking Number
                </label>
                <input
                  type="text"
                  placeholder="Package tracking number"
                  name="packageTrackingNo"
                  id="packageTrackingNo"
                  onChange={onChange}
                  value={data.packageTrackingNo}
                  className={inputStyle}
                />
                {packageTrackingNoError ? (
                  <span className="text-themeRed text-xs">
                    Tracking No. is required!
                  </span>
                ) : (
                  ""
                )}
              </div>
              <div>
                <label htmlFor="packageTrackingLink" className={labelStyle}>
                  Package Tracking Link
                </label>
                <input
                  type="text"
                  placeholder="Package Tracking link"
                  name="packageTrackingLink"
                  id="packageTrackingLink"
                  onChange={onChange}
                  value={data.packageTrackingLink}
                  className={inputStyle}
                />
                {packageTrackingLinkError ? (
                  <span className="text-themeRed text-xs">
                    Tracking Link is required!
                  </span>
                ) : (
                  ""
                )}
              </div>
              <div className="space-y-2">
                <label htmlFor="commercialInvoice" className={labelStyle}>
                  Supplier commercial invoice (.png , .jpg , .webp & pdf)
                </label>
                <label
                  htmlFor="commercialInvoice"
                  className="flex items-start gap-x-4 w-full bg-white text-black text-opacity-40 font-medium 
                    text-base rounded py-3 px-6 cursor-pointer"
                >
                  <FaCloudUploadAlt size={24} />
                  <span>
                    {selectedImage === "" ? "Upload File" : selectedImage?.name}
                  </span>
                </label>
                <input
                  onChange={(event) => {
                    setselectimageLinkError(false);
                    localStorage.setItem("invoice", event.target.files[0]);
                    setSelectedImage(event.target.files[0]);
                  }}
                  type="file"
                  name="commercialInvoice"
                  id="commercialInvoice"
                  className="hidden"
                  accept=".png, .jpg, .jpeg, .webp, .pdf"
                />
                {selectimageLinkError ? (
                  <span className="text-themeRed text-xs">
                    Commercial Invoice is required!
                  </span>
                ) : (
                  ""
                )}
                {selectedImage && (
                  <div className="p-4">
                    {selectedImage.type.startsWith("image/") ? (
                      <img
                        alt="not fount"
                        width={"90px"}
                        src={window.URL.createObjectURL(selectedImage)}
                      />
                    ) : (
                      ""
                    )}
                    <button
                      className="mt-2  btn btn-danger btn-sm button-border"
                      onClick={() => setSelectedImage(null)}
                    >
                      Remove
                    </button>
                  </div>
                )}
              </div>
              <div className="space-y-2">
                <label htmlFor="commercialInvoice" className={labelStyle}>
                  Supplier packing list (.png , .jpg , .webp & pdf)
                </label>
                <label
                  htmlFor="supplierList"
                  className="flex items-start gap-x-4 w-full bg-white text-black text-opacity-40 font-medium 
                    text-base rounded py-3 px-6 cursor-pointer"
                >
                  <FaCloudUploadAlt size={24} />
                  {listImage === "" ? "Upload File" : listImage?.name}
                </label>
                <input
                  onChange={(event) => {
                    setlistimageLinkError(false);
                    localStorage.setItem("supplierList", event.target.files[0]);
                    setListImage(event.target.files[0]);
                  }}
                  type="file"
                  name="supplierList"
                  id="supplierList"
                  accept=".png, .jpg, .jpeg, .webp, .pdf"
                  className="hidden"
                />
                {listimageLinkError ? (
                  <span className="text-themeRed text-xs">
                    List Image is required!
                  </span>
                ) : (
                  ""
                )}
                {listImage && (
                  <div className="p-4">
                    {listImage.type.startsWith("image/") ? (
                      <img
                        alt="not fount"
                        width={"90px"}
                        src={window.URL.createObjectURL(listImage)}
                      />
                    ) : (
                      ""
                    )}
                    <button
                      className="mt-2  btn btn-danger btn-sm button-border"
                      onClick={() => setListImage(null)}
                    >
                      Remove
                    </button>
                  </div>
                )}
              </div>
              {/* <div
                className={`[&>button>div]:border-none checked:[&>button>div]:bg-black flex items-center gap-x-3`}
                id="two"
              >
                <label
                  htmlFor="insurance"
                  className="font-normal sm:text-xl text-lg text-black text-opacity-60"
                >
                  Do you want Repack your Parcel?
                </label>
                <ToggleSwitch
                  checked={wayBill ? true : false}
                  onClick={!wayBill ? toggle : toggleBack}
                  name="insurance"
                  id="insurance"
                  className={`${wayBill ? "[&>div]:bg-themeRed" : "[&>div]:bg-gray-200"
                    }`}
                />
                <div className="max-w-[24px]">
                  <FaRegQuestionCircle
                    size={24}
                    className="md:block hidden text-black text-opacity-60"
                  />
                </div>
              </div> */}
              <div className="flex sm:flex-row flex-col sm:justify-end sm:items-center gap-x-4 gap-y-3">
                <div>
                  <Link
                    className="bg-transparent text-themeBlue font-medium xl:text-xl lg:text-lg py-3 px-12 rounded-lg 
                    border border-themeBlue flex justify-center items-center gap-x-2 hover:bg-themeBlue 
                    hover:text-white sm:w-auto w-full"
                    to="/package_details"
                  >
                    <FaArrowLeft />
                    <span>Back</span>
                  </Link>
                </div>
                <div>
                  <Link
                    className="bg-themeBlue text-white font-medium xl:text-xl lg:text-lg py-3 px-12 rounded-lg 
                    border border-themeBlue flex justify-center items-center gap-x-2 hover:bg-transparent hover:text-themeBlue 
                    sm:w-auto w-full"
                    onClick={add_supplier_detail}
                  >
                    <span>Next</span>
                    <FaArrowRight />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
